import { render } from "./OcMoveContent.vue?vue&type=template&id=9095be52&scoped=true"
import script from "./OcMoveContent.vue?vue&type=script&lang=js"
export * from "./OcMoveContent.vue?vue&type=script&lang=js"

import "./OcMoveContent.vue?vue&type=style&index=0&id=9095be52&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9095be52"]])

export default __exports__